import { motion } from 'framer-motion'
import './Legal.css'

export default function LegalPage({ title, children }) {
  return (
    <section className="legal-section">
      <div className="legal-container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="legal-content"
        >
          <h1>{title}</h1>
          <div className="legal-text">
            {children}
          </div>
        </motion.div>
      </div>
    </section>
  )
}

